var VerticalLayout2Module = /** @class */ (function () {
    function VerticalLayout2Module() {
    }
    return VerticalLayout2Module;
}());
export { VerticalLayout2Module };
